/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import baustein from "baustein";

export default {
    enter: function() {
        return baustein.getInstanceOf("lyst-app");
    },

    update: function() {},

    exit: function() {
        console.error("The lyst-app route should never be exited!");
    }
};

